import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const LINKS = [
  ["#concerns", "Health Concerns"],
  ["#products", "Products"],
  ["#packages", "Care Packages"],
  ["#about", "Why Natural"],
  ["#gallery", "Gallery"],
  ["#testimonials", "Results"],
  ["#contact", "Contact"],
];

export default function Header({ onCartClick, onLoginClick }) {
  const { count } = useCart();
  const { user, isAuthenticated, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const firstName = user?.name?.split(" ")[0];

  return (
    <header>
      <div className="container nav">
        <a href="#home" className="brand">
          <div className="mark">
            <i className="fa-solid fa-seedling" />
          </div>
          <div>
            <b>Green World Nature Pride</b>
            <span>Healthcare</span>
          </div>
        </a>
        <button className="menu-toggle" onClick={() => setOpen((o) => !o)}>
          <i className="fa-solid fa-bars" />
        </button>
        <ul className={`nav-links${open ? " open" : ""}`}>
          {LINKS.map(([href, label]) => (
            <li key={href}>
              <a href={href} onClick={() => setOpen(false)}>
                {label}
              </a>
            </li>
          ))}
          <li>
            {isAuthenticated ? (
              <span className="acct">
                <i className="fa-solid fa-circle-user" /> {firstName}
                <button className="link-btn" onClick={logout}>
                  Log out
                </button>
              </span>
            ) : (
              <button className="link-btn" onClick={onLoginClick}>
                <i className="fa-solid fa-user" /> Login
              </button>
            )}
          </li>
          <li>
            <button className="cart-btn" onClick={onCartClick}>
              <i className="fa-solid fa-basket-shopping" /> Cart <span className="count">{count}</span>
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}
